const iconProps = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
};

export function FollowChannelIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M11 5L6 9H2v6h4l5 4V5z" />
            <path d="M15.5 8.5a4.5 4.5 0 010 7" />
            <path d="M18.5 6a8 8 0 010 12" />
        </svg>
    );
}

export function JoinChannelIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
            <circle cx="9" cy="7" r="3" />
            <path d="M19 8v6M22 11h-6" />
        </svg>
    );
}

export function ReactPostIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M7 10v12" />
            <path d="M15 5.88 14 10h5.83a2 2 0 011.92 2.56l-2.33 8A2 2 0 0117.5 22H4a2 2 0 01-2-2v-8a2 2 0 012-2h2.76a2 2 0 001.79-1.11L12 2a3.13 3.13 0 013.7 3.7L15 5.88z" />
        </svg>
    );
}

export function CheckOutIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    );
}

export function TakeLookIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="2.5" />
        </svg>
    );
}

export function CommentIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
        </svg>
    );
}

export function ShowLoveIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.6l-1-1a5.5 5.5 0 00-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 000-7.8z" />
        </svg>
    );
}

export function JumpInIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="19"
            viewBox="0 0 22 19"
            fill="none"
            aria-hidden
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4285 0.0611251C11.1099 0.384981 10.26 1.703 10.514 3.03032C10.5377 3.1541 10.5531 3.25928 10.5484 3.26406C10.5436 3.26887 10.2407 3.16754 9.87527 3.03889C8.48104 2.54813 7.75621 2.30949 7.54591 2.27195C7.05477 2.18432 6.46554 2.23881 6.00997 2.41398C5.64272 2.55519 3.28355 3.67962 3.11658 3.79303C2.6934 4.08039 2.4755 4.49972 2.47629 5.02525C2.47669 5.30403 2.52353 5.49493 2.64954 5.73136C2.78748 5.99015 2.91949 6.12853 3.16722 6.27398C3.54301 6.49465 3.91855 6.57741 4.28035 6.51933C4.55864 6.47469 4.66327 6.43457 5.29215 6.13152C5.59932 5.98349 6.0918 5.74929 6.38654 5.61106L6.92244 5.35974L7.8494 5.76482C8.69644 6.13499 8.77566 6.17558 8.76839 6.23545C8.75924 6.31085 8.45659 7.67116 8.1254 9.1253C8.00023 9.67496 7.88932 10.1663 7.87889 10.2172C7.86223 10.2988 7.71163 10.4205 6.6091 11.2434C5.9211 11.7569 5.34189 12.1894 5.32196 12.2045C5.29583 12.2243 5.122 12.0744 4.69916 11.6677C4.37655 11.3573 3.94966 10.9492 3.75051 10.7607C3.55135 10.5723 3.27761 10.3129 3.14219 10.1842C2.80527 9.864 2.66588 9.75572 2.45421 9.64967C2.18464 9.51462 1.93338 9.46451 1.60691 9.48065C0.984868 9.51144 0.46467 9.83668 0.195041 10.3635C0.0393124 10.6677 -0.000430999 10.8286 3.51244e-06 11.153C0.000409057 11.4735 0.0734069 11.7445 0.223864 11.9842C0.346773 12.18 3.44229 15.3165 3.68023 15.4863C3.93149 15.6656 4.35801 15.8612 4.66472 15.938C4.88302 15.9926 5.00103 16.0026 5.41613 16.0019C6.01921 16.0008 6.04067 15.9962 7.2266 15.6114C7.72846 15.4486 8.47799 15.2114 8.89223 15.0845C9.30646 14.9575 9.69576 14.838 9.75734 14.819C9.84529 14.7918 9.92289 14.7924 10.1194 14.822C10.257 14.8427 10.4478 14.8598 10.5434 14.86C10.7127 14.8603 11.9269 14.7411 13.9414 14.5262C14.8145 14.4331 14.9411 14.4254 14.9842 14.4623C15.0556 14.5234 16.7994 15.9738 17.8125 16.8146C19.4461 18.1705 19.4715 18.1893 19.8261 18.3135C20.0573 18.3944 20.4588 18.4127 20.7091 18.3537C21.0351 18.2768 21.2634 18.1487 21.5109 17.9036C21.859 17.5588 22 17.2204 22 16.7293C22 16.4257 21.9504 16.2077 21.8249 15.959C21.6823 15.6765 21.7907 15.7784 19.1612 13.4562C18.6753 13.0271 18.123 12.5386 17.934 12.3708C17.745 12.2029 17.4973 11.9831 17.3836 11.8824C17.0378 11.5761 16.6129 11.3099 16.2805 11.1915C16.1723 11.153 15.531 10.9868 13.4708 10.4636C13.0416 10.3546 12.6859 10.2517 12.6803 10.235C12.6716 10.2088 13.3422 8.56174 13.375 8.52904C13.3815 8.52246 13.7313 8.64224 14.1522 8.79522C15.2185 9.18277 15.3711 9.21959 15.8444 9.20348C16.0519 9.19642 16.3055 9.16939 16.4093 9.14329C16.5128 9.11725 17.0994 8.98455 17.7128 8.8484C18.9765 8.56797 19.1155 8.51797 19.417 8.23536C19.7475 7.92553 19.9149 7.54342 19.9136 7.10178C19.9132 6.96404 19.8995 6.79307 19.8831 6.72181C19.768 6.22227 19.3088 5.74014 18.8003 5.58496C18.4825 5.48797 18.2634 5.50286 17.08 5.70196L16.0271 5.87906L15.3275 5.55078C14.9426 5.37022 14.4862 5.15143 14.3131 5.06462L13.9984 4.90674L14.2552 4.76382C14.5742 4.58616 15.0023 4.17132 15.1807 3.86696C15.4571 3.39519 15.5548 2.99417 15.5338 2.41789C15.5221 2.09728 15.5068 2.00276 15.4288 1.76757C15.1813 1.02108 14.6735 0.476373 13.9421 0.172852C13.513 -0.00523947 12.8869 -0.0514714 12.4285 0.0611251ZM12.7326 0.971659C11.9817 1.10757 11.3988 1.7972 11.3988 2.54969C11.3988 3.25169 11.9213 3.92234 12.6194 4.11631C12.7844 4.16216 13.2321 4.16231 13.3967 4.11657C14.1177 3.91617 14.6133 3.27787 14.6133 2.54969C14.6133 2.10101 14.4444 1.71589 14.1073 1.39563C13.722 1.02968 13.2376 0.880266 12.7326 0.971659ZM6.75823 3.18764C6.49262 3.23245 6.30517 3.30464 5.64787 3.61526C5.28144 3.7884 4.7033 4.05927 4.36317 4.21714C4.023 4.37504 3.7121 4.53683 3.67227 4.57666C3.53548 4.71344 3.48117 4.86068 3.4982 5.04854C3.51964 5.28488 3.61981 5.42958 3.82785 5.52485C4.09302 5.64622 4.11199 5.64008 5.50304 4.98313C6.47313 4.52498 6.78091 4.39196 6.89455 4.38168C7.0216 4.37018 7.08338 4.38712 7.37251 4.5127C8.84432 5.15192 9.54084 5.45895 9.60645 5.49745C9.71293 5.55996 9.8047 5.73512 9.8047 5.87591C9.8047 5.9405 9.7521 6.22549 9.68779 6.50925C9.51439 7.27443 9.02687 9.44817 8.9614 9.7481C8.93012 9.89149 8.89759 10.0316 8.88916 10.0595C8.87473 10.1073 8.95349 10.1102 10.2635 10.1102H11.6531L11.957 9.39325C12.9204 7.12061 12.9325 7.08672 12.9321 6.66307C12.9316 6.26981 12.8476 5.99111 12.6238 5.64057C12.3736 5.2487 12.0946 5.03426 11.3305 4.6465C10.8293 4.39219 10.6485 4.32169 9.17611 3.80659C7.34708 3.1667 7.16247 3.11942 6.75823 3.18764ZM13.8103 5.94708C13.9132 6.21535 13.9103 7.00028 13.8048 7.39928C13.7715 7.5254 13.7475 7.63067 13.7515 7.63325C13.7555 7.63582 14.039 7.7388 14.3816 7.86209C14.7241 7.98537 15.0891 8.11973 15.1926 8.16069C15.3395 8.21877 15.4479 8.23794 15.6851 8.24793C16.0069 8.26149 16.0036 8.26213 18.366 7.73704C18.6512 7.67363 18.6945 7.65126 18.8232 7.50092C19.1278 7.14503 18.9534 6.61527 18.4897 6.48834C18.4018 6.46426 18.1812 6.49257 17.2296 6.64995C16.5005 6.77057 16.0229 6.83661 15.9313 6.82946C15.7743 6.81718 15.6561 6.76718 14.588 6.26123C13.8216 5.89821 13.786 5.88384 13.8103 5.94708ZM1.55894 10.4316C1.06621 10.5227 0.800779 11.0324 1.02293 11.4607C1.05697 11.5263 1.72386 12.2132 2.62587 13.1118C3.90545 14.3864 4.20532 14.6707 4.37331 14.7682C4.63879 14.9223 4.88122 15.0006 5.19207 15.0327C5.62499 15.0774 5.82446 15.0365 6.98038 14.6658C7.55393 14.482 8.17311 14.2852 8.35633 14.2286C8.53955 14.172 8.69432 14.1222 8.70026 14.118C8.70623 14.1137 8.62022 14.0116 8.50916 13.8911C8.09698 13.4437 7.85809 12.8309 7.80436 12.0832C7.78761 11.8504 7.77136 11.6433 7.76821 11.6229C7.76508 11.6025 7.2476 11.9704 6.61828 12.4404C5.4071 13.345 5.36466 13.3701 5.1297 13.319C4.96485 13.2832 5.14372 13.447 2.91045 11.287C2.03642 10.4417 1.91606 10.3655 1.55894 10.4316ZM8.76781 11.7251C8.7781 12.3621 8.78125 12.3922 8.8619 12.6261C9.06259 13.2081 9.51066 13.6463 10.0713 13.8086C10.4433 13.9164 10.3001 13.9258 13.6404 13.5728C14.9941 13.4298 15.1464 13.4214 15.2912 13.4819C15.3791 13.5186 15.7216 13.7982 17.1335 14.9856C18.9384 16.5037 19.9603 17.3445 20.053 17.3875C20.2003 17.4559 20.5013 17.454 20.656 17.3837C21.0766 17.1927 21.2028 16.5923 20.8894 16.2724C20.8391 16.2209 20.3742 15.8073 19.8564 15.3532C19.3386 14.8992 18.8362 14.456 18.7399 14.3684C17.7344 13.4531 16.4862 12.3626 16.3447 12.2758C16.2475 12.2162 16.0973 12.141 16.0109 12.1087C15.9244 12.0763 14.9686 11.8285 13.8868 11.558L11.92 11.0661H10.3385H8.75712L8.76781 11.7251Z"
                fill="currentColor"
            />
        </svg>
    );
}

export function RetweetIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M17 2l4 4-4 4" />
            <path d="M3 11V9a4 4 0 014-4h14" />
            <path d="M7 22l-4-4 4-4" />
            <path d="M21 13v2a4 4 0 01-4 4H3" />
        </svg>
    );
}

export function ShareIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            aria-hidden
            {...props}
        >
            <path
                d="M0.803467 12.4694V19.1361C0.803467 19.5781 0.995025 20.002 1.336 20.3146C1.67698 20.6271 2.13944 20.8027 2.62165 20.8027H18.9853C19.4675 20.8027 19.93 20.6271 20.2709 20.3146C20.6119 20.002 20.8035 19.5781 20.8035 19.1361V12.4694M10.8035 14.9694V1.2194M16.258 5.80273L10.8035 0.802734L5.34892 5.80273"
                stroke="currentColor"
                strokeWidth="1.60714"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function WatchVideoIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="M10 9l6 3-6 3V9z" fill="currentColor" stroke="none" />
        </svg>
    );
}

export function WatchStreamIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <path d="M4 7h16v10H4z" />
            <path d="M8 11l5 2-5 2v-4z" fill="currentColor" stroke="none" />
            <path d="M20 9v6" />
        </svg>
    );
}

export function ExploreIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <circle cx="12" cy="12" r="9" />
            <path d="M14.5 9.5L10 14l-2.5-2.5" />
            <path d="M16 8l-1.5 3.5L11 13" />
        </svg>
    );
}

export function GoGoIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <circle cx="12" cy="5" r="2" />
            <path d="M10 22v-6l-2-4 4-2 4 2-2 4v6" />
            <path d="M8 12l4-2 4 2" />
        </svg>
    );
}

export function LetsGoIcon(props) {
    return (
        <svg {...iconProps} {...props}>
            <circle cx="12" cy="6" r="2" />
            <path d="M12 8v8" />
            <path d="M9 20h6" />
            <path d="M10 14l-2 3M14 14l2 3" />
        </svg>
    );
}
